import { DateFormat, formatDateWithYear } from '@lyearn/core/utils/date/formatDate';
import { TFunction } from '@lyearn/i18n';
import { getUsersName } from '@/modules/events/views/EventManager/utils';
import { EventTypeEnum, EventUnion } from '@/types/schema';

export const getEventInstructorInfo = (t: TFunction, event: EventUnion) => {
  const { instructors, type } = event;
  const isLive = type === EventTypeEnum.Live;
  const translationKey = isLive
    ? 'Channel:Events.LiveEventwithInstructor'
    : 'Channel:Events.OfflineEventWithInstructor';

  return t(translationKey, { instructor: getUsersName(t, instructors) });
};

export const getEventTypeInfo = (t: TFunction, { type }: EventUnion) => {
  const isLive = type === EventTypeEnum.Live;
  const translationKey = isLive ? 'Common:ResourceType.Live' : 'Common:ResourceType.Offline';

  return t(translationKey);
};

export const getEventTimeInfo = (_t: TFunction, { startTime }: EventUnion) => {
  const startDate = formatDateWithYear(startTime, DateFormat.DateTime);

  return `on ${startDate}`;
};
